const DECIMAL_PATTERN = /^\d+(\.\d{1,2})?$/

/** Parses a plain decimal string (max 2 dp) into integer minor units. */
export const toMinorUnits = (value: string): null | number => {
  const trimmed = value.trim()
  if (!DECIMAL_PATTERN.test(trimmed)) return null

  const [whole, fraction = ''] = trimmed.split('.')
  const minor = Number(`${whole}${fraction.padEnd(2, '0')}`)

  return Number.isSafeInteger(minor) ? minor : null
}
